<template>
  <div class="row no-gutters align-items-center fd-level-bar">
    <div v-if="label" class="col-7">
      <FdText class="fd-level-bar__label" tag="span">{{ label }}</FdText>
    </div>
    <div :class="['col', { 'pl-2': label }]">
      <div
          class="d-flex overflow-hidden fd-level-bar__bar-wrapper w-100 rounded-1"
      >
        <div
            class="fd-level-bar__bar"
            :style="{
            width: percentage + '%',
            backgroundColor: color,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import FdText from "@/flexdesign/Text";

export default {
  name: "FdLevelBar",

  components: {
    FdText,
  },

  props: {
    color: String,
    label: String,
    percentage: Number,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/dimensions";

/* =========================================================================
 * LEVEL BAR
 * ========================================================================= */

.fd-level-bar {
  &__label {
  }

  &__bar-wrapper {
    height: 6px;
    background-color: $gmb-color-white;
  }

  &__bar {
  }
}
</style>
